import { Navigate, Outlet } from "react-router-dom";
import { useSelector } from "react-redux";
import { RootState } from "@/redux/store";
import { ROLE_BOM } from "@/lib/utils";
import { routes } from "@/routes/utils";

const BomProtectedRoute = () => {
  const currentRole = useSelector(
    (state: RootState) => state.currentData.currentRole
  );

  const isBom = currentRole === ROLE_BOM;

  if (!isBom) {
    return <Navigate to={`/${routes.owner}/${routes.dashboard}`} replace />;
  }

  return <Outlet />;
};

export default BomProtectedRoute;
